/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsPlatformAdminUpdateInput } from "../../entities/models/PlatformAdminUpdateInput";
import { z } from "zod/v4";

export const modelsPlatformAdminUpdateInputSchema = z.object({
    "email": z.optional(z.string()),
"is_active": z.optional(z.boolean()),
"name": z.optional(z.string()),
"password": z.optional(z.string().min(12).max(72))
    }) as unknown as z.ZodType<ModelsPlatformAdminUpdateInput>